import { z } from "zod/v4-mini";

import { Schema, cz } from "@/utils/zodUtils.ts";

import { FrenchIdentity, frenchIdentitySchema } from "./identity/FrenchIdentity";

/*********************************
 *            Patient            *
 *********************************/

export type PatientID = {
  id: string;
};

export const patientIDSchema: Schema<PatientID> = z.object({
  id: z.string(),
});

export type Patient = {
  id: string;
  givenName: string;
  familyName: string;
  contactPhone: string;
  email: string;
  addressLine?: string;
  addressPostalCode?: string;
  addressCity?: string;
  lastLogin?: string;
} & FrenchIdentity;

export const patientSchema: Schema<Patient> = z.intersection(
  frenchIdentitySchema,
  cz.camelCaseObject({
    id: z.string(),
    givenName: z.string(),
    familyName: z.string(),
    contactPhone: z.string(),
    email: z.string(),
    addressLine: cz.optional(z.string()),
    addressPostalCode: cz.optional(z.string()),
    addressCity: cz.optional(z.string()),
    last_login: cz.optional(cz.datetime()),
  }),
);
